/**
 * @file store/index.js
 *
 * Completely generic data store that can be used under any paradigm (client or server).
 *
 * @see the README for more information - https://code.devops.fds.com/polaris/core/lib/blob/master/store/README.md
 */
const Store = require('./Store');

module.exports = new Store();



// WEBPACK FOOTER //
// ../lib/store/index.js